<template>
<div class="expertCookbookindex"  >
    <div class="top">   
         <el-button type="primary" size="medium" @click="expertCookbookadd()">添加</el-button>   
    </div>
    <div class="subject" :style="`height: ${windowHeight - 180}px;`">
      <div class="ul">
        <div class="li" v-for="item in datalist" :label="item.id"  :key="item.id">
            <div  class="li-big" @click="expertCookbookInfo(item.id)">
                <div class="name">{{item.name}}</div>
            </div>
            <div class="type-gree" v-if="item.showMenu==1">已发布</div>
            <div class="type-red" v-if="item.showMenu==0">未发布</div>
            <i class="el-icon-close" @click="deletePublicMenus(item.id)"></i>         
        </div>
      </div>
        
    </div>    
</div> 
</template>
<script>
import { publicMenuList,deletePublicMenu} from "@/api/foodSetting";
import mixin from "@/mixins/windowResize";
export default {
  data() {
    return {
      datalist: []
    };
  },
  mixins: [mixin],
  created() {
     this.publicMenuLists();
  },
  methods: {
      publicMenuLists(){
        publicMenuList()
      .then(res => res.data)
      .then(data => {
        if (data.code == 200 && data.data) {
          this.datalist = data.data;
        }
      });
      },
    //详情
    expertCookbookInfo(id) {
      this.$router.push({
        path: "expertCookbookInfo",
        query: { id: id }
      });
    },
     //新增
    expertCookbookadd() {
      this.$router.push({
        path: "expertCookbookadd"
      });
    },
    //删除
    deletePublicMenus(id){
         this.$confirm("确定要删除吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          deletePublicMenu(id)
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.publicMenuLists();
              }
            })
            .catch(function(error) {});
        })
        .catch(() => {});
    },
  }
};
</script>
<style lang="scss" scoped>
.expertCookbookindex {
  padding: 12px;
  * {
    box-sizing: border-box;
  }
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .subject {
    padding-top: 10px;
    overflow: auto;
    .ul {
      overflow: auto;
      .li {
        position: relative;
        float: left;
        width: 225px;
        height: 140px;
        font-size: 17px;
        box-shadow: 0 1px 2px #c5c5c5;
        margin: 15px 14px;
        padding: 10px;
        text-align: center;
        border-radius: 5px;
        overflow: hidden;
        background-image: url(https://cdnfile-10043692.file.myqcloud.com/admin/images/shanshi/zhuanjiafengmian.jpg);
        cursor: pointer;
        .li-big{
            width: 100%;
            height: 100%;
        }
        .type-gree {
          position: absolute;
          left: 0;
          top: 0;
          background: #3cc51f;
          color: #fff;
          font-size: 14px;
          line-height: 28px;
          width: 60px;
          font-weight: 600;
          border-radius: 5px 0 5px 0;
        }
        .type-red {
          position: absolute;
          left: 0;
          top: 0;
          background: #f76260;
          color: #fff;
          font-size: 14px;
          line-height: 28px;
          width: 60px;
          font-weight: 600;
          border-radius: 5px 0 5px 0;
        }
        .el-icon-close {
          position: absolute;
          right: 5px;
          top: 5px;
          font-size: 20px;
          color:#909399;
          z-index: 1000;
        }
        .el-icon-close:hover{
          color: red;
        }
        .name {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0px;
          height: 40px;
          line-height: 40px;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/foodSetting/expertCookbookindex.vue